// extracted by mini-css-extract-plugin
export default {"mainContainer":"SubhankarConsulting_mainContainer__2TepQ","nextProj":"SubhankarConsulting_nextProj__Lb4bC"};